module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cb317a2b69045c85ab5eedc7b65ecbcd.png";